import script from "./TaskEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEditor.vue?vue&type=script&setup=true&lang=js"

import "./TaskEditor.vue?vue&type=style&index=0&id=9bcae50e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bcae50e"]])

export default __exports__